import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faCheckCircle,
  faCalendarAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import jsPDF from "jspdf";

@Component({
  selector: "app-factura",
  templateUrl: "./factura.component.html",
  styleUrls: ["./factura.component.css"],
})
export class FacturaComponent implements OnInit {
  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoVal = faCheckCircle;
  icoFec = faCalendarAlt;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  formLis = 0;
  SwExcel = false;
  SwImpre = false;
  SwLista = false;
  resul: boolean;

  prifec: string;
  ultfec: string;

  constructor(
    private srvCentral: CentralService,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }
    this.formLis = this.srvCentral.EntFormLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    switch (this.formLis) {
      case 0:
        this.SwLista = true;
        break;
      case 1:
        this.SwImpre = true;
        break;
      case 2:
        this.SwExcel = true;
        break;
    }
  }

  persiana(): void {
    $("#wrapper").toggleClass("toggled");
  }

  formas(fm: number): void {
    this.formLis = fm;
  }

  listado(): void {
    const fec1 = this.srvCentral.cadenaFecha(this.prifec);
    const fec2 = this.srvCentral.cadenaFecha(this.ultfec);
    if (fec1 > fec2) {
      const modalRef = this.modalService.open(AvisosComponent);
      modalRef.componentInstance.datAviso = {
        tit: "FECHAS ERRÓNEAS",
        tex: "Fecha inicial posterior a fecha final",
        tip: 1,
        btcan: "",
        btno: "",
        btsi: "Aceptar",
      };
      modalRef.result.then((result) => {});
    } else {
      this.srvCentral.EntFormLis = this.formLis;
      this.srvCentral.gnPriDia = fec1;
      this.srvCentral.gnUltDia = fec2;
      if (this.formLis === 0) {
        this.router.navigate(["/factulis"]);
      }
      if (this.formLis === 1) {
        this.router.navigate(["/factuimp"]);
      }
      if (this.formLis === 2) {
        this.listadoExcel();
      }
    }
  }

  listadoExcel(): void {
    this.resul = true;
    this.srvCentral
      .consulFactura(1, this.prifec, this.ultfec)
      .subscribe((datos) => {
        if (datos[0].facFech === "?") {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].facErro,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          modalRef.result.then((result) => {});
        } else {
          this.resul = false;
          const tx = this.srvCentral.saca(datos[0].facFech);
          const url = this.srvCentral.UrlCave + "/" + tx;
          window.open(url, "_blank");
        }
      });
  }

  descargarPDF(): void {
    const fec1 = this.srvCentral.cadenaFecha(this.prifec);
    const fec2 = this.srvCentral.cadenaFecha(this.ultfec);

    if (fec1 > fec2) {
      const modalRef = this.modalService.open(AvisosComponent);
      modalRef.componentInstance.datAviso = {
        tit: "FECHAS ERRÓNEAS",
        tex: "Fecha inicial posterior a fecha final",
        tip: 1,
        btcan: "",
        btno: "",
        btsi: "Aceptar",
      };
      return;
    }

    this.resul = true;
    this.srvCentral
      .consulFactura(0, this.prifec, this.ultfec)
      .subscribe((datos) => {
        this.resul = false;

        if (datos[0]?.facFech === "?") {
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].facErro,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          return;
        }

        const clienteNombre = this.srvCentral.datosIden?.UsuNom || "Cliente";

        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const titleColor: [number, number, number] = [30, 60, 90];
        const textColor: [number, number, number] = [50, 50, 50];
        const lineColor: [number, number, number] = [200, 200, 200];
        const headerColor: [number, number, number] = [240, 240, 240];

        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.setTextColor(...titleColor);
        doc.text("Listado de Facturas", 20, 20);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);
        doc.setTextColor(...textColor);
        doc.text(`Cliente: ${clienteNombre}`, 20, 30);
        doc.text(`Periodo: ${this.prifec} - ${this.ultfec}`, 20, 40);

        doc.setDrawColor(...lineColor);
        doc.line(20, 45, 190, 45);

        let y = 55;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setFillColor(...headerColor);
        doc.rect(20, y, 35, 8, "F"); // Factura
        doc.rect(55, y, 30, 8, "F"); // Fecha
        doc.rect(85, y, 30, 8, "F"); // Ventas
        doc.rect(115, y, 25, 8, "F"); // IVA
        doc.rect(140, y, 35, 8, "F"); // Total Neto

        doc.setTextColor(...textColor);
        doc.text("Factura", 22, y + 5);
        doc.text("Fecha", 57, y + 5);
        doc.text("Ventas €", 87, y + 5);
        doc.text("IVA €", 117, y + 5);
        doc.text("Total €", 142, y + 5);

        doc.setDrawColor(...lineColor);
        doc.line(20, y + 8, 190, y + 8);

        y += 14;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);

        for (const item of datos) {
          if (item.facFech === "TOTALES") continue;

          const factura = `${item.facSeri}-${item.facNume}`;
          const fecha = item.facFech || "Sin fecha";
          const ventas = item.facVtas
            ? parseFloat(item.facVtas).toFixed(2)
            : "0.00";
          const iva = item.facIvas
            ? parseFloat(item.facIvas).toFixed(2)
            : "0.00";
          const total = item.facNeto
            ? parseFloat(item.facNeto).toFixed(2)
            : "0.00";

          if (y > 280) {
            doc.addPage();
            y = 20;

            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.setFillColor(...headerColor);
            doc.rect(20, y, 35, 8, "F");
            doc.rect(55, y, 30, 8, "F");
            doc.rect(85, y, 30, 8, "F");
            doc.rect(115, y, 25, 8, "F");
            doc.rect(140, y, 35, 8, "F");

            doc.setTextColor(...textColor);
            doc.text("Factura", 22, y + 5);
            doc.text("Fecha", 57, y + 5);
            doc.text("Ventas €", 87, y + 5);
            doc.text("IVA €", 117, y + 5);
            doc.text("Total €", 142, y + 5);

            doc.setDrawColor(...lineColor);
            doc.line(20, y + 8, 190, y + 8);
            y += 12;
          }

          doc.setTextColor(...textColor);
          doc.text(factura, 22, y);
          doc.text(fecha, 57, y);
          doc.text(ventas, 113, y, { align: "right" });
          doc.text(iva, 138, y, { align: "right" });
          doc.text(total, 173, y, { align: "right" });

          y += 7;
        }

        const pageCount = doc.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setFontSize(9);
          doc.setTextColor(120, 120, 120);
          doc.text(`Página ${i} de ${pageCount}`, 190, 290, { align: "right" });
          doc.text(`Generado: ${new Date().toLocaleString()}`, 20, 290);
        }

        const nombreArchivo = `Facturas_${this.prifec.replace(
          /\//g,
          "-"
        )}_${this.ultfec.replace(/\//g, "-")}.pdf`;
        doc.save(nombreArchivo);
      });
  }
}
